/**
 * On mode switch in property level
 * @param {TimelineMapProps} timeline
 * @param {PropertyValueProps} property
 * @param {Boolean} switched
 * @param {Boolean} enter
 */
const onModeSwitch = (timeline, property, switched, enter) => {
  if (switched) {
    if (property.get("o_delay") && !property.get("paused")) {
      property.set("delayed", true);
    }

    property.set("paused", false);
    property.set("done", false);
    timeline.set("is-alternating", false);
    timeline.set("finished", 0);

    if (!enter && property.get("is-alternating")) {
      property.set("enter-start-time", null);
      property.set("enter", null);
      return;
    }

    property.set("enter-start-time", null);
    property.set("leave-start-time", null);
  }
};

export default onModeSwitch;
